import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import styled from "styled-components"
import InputPassword from "../../shared/input/new/InputPassword"
import { getUetdsExcelSpecial } from "../../../features/admin/adminSlice"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 500px;
        height: 300px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .input{
            width:400px;
        }
        .button-grp{
            height: 80px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
            width: 400px;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            margin-right: 8px;
        }
    }
`
const UetdsExcelSpecialModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [password, setPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"U-ETDS Yük Bildirimi Şifre Girişi"}/>
        <div className="input">
            <InputPassword data={password} setData={(e) => setPassword(e.target.value)} name={"password"} inputWidth={"100%"} labelText={"U-ETDS Excel İndirme Şifresi"} showPassword={() => setShowPassword(!setPassword)} type={showPassword ? "text" : "password"} isShow={showPassword} />
        </div>
        <div className='button-grp'>
            <Btn color={"#E85546"} background={"transparent"} width="160px" radius={"10px"} padding="0 10px" handleClick={()=> dispatch(getUetdsExcelSpecial(password))}>Gönder</Btn>
            <Btn color={"#E85546"} background={"transparent"} width="160px" radius={"10px"} padding="0 10px" handleClick={()=> dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
        </div>
    </ModalContainer>
  )
}

export default UetdsExcelSpecialModal